/**
 * useLazyQuery の execute が返すPromiseのrejectを握りつぶす。
 *
 * Apollo Client 3 の execute はリクエストエラーでもrejectせず、エラーは hook の戻り値
 * （result.error）にだけ出ていた。Apollo Client 4 では execute のPromiseが reject される
 * ため、エラー表示を result.error で行っている呼び出し（結果をPromiseで受け取らない箇所）で
 * 未処理のPromise拒否にならないよう `.catch(ignoreRejection)` として使う。
 */
export const ignoreRejection = (): undefined => undefined;
